import ServiceBase from './ServiceBase';

export default class OrderCommunicationService extends ServiceBase {
    constructor($http, errorHandler) {
        super($http, errorHandler);
    }

    dismissOrderCommunication(orderCommunicationID) {
        const params = {
            orderCommunicationID,
        };

        return this.request('post', 'orderCommunication/dismissOrderCommunication', params);
    }
}